import { render, staticRenderFns } from "./reimbursement-details.vue?vue&type=template&id=2606fccc"
import script from "./reimbursement-details.vue?vue&type=script&lang=js"
export * from "./reimbursement-details.vue?vue&type=script&lang=js"
import style0 from "./reimbursement-details.vue?vue&type=style&index=0&id=2606fccc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports